// extracted by mini-css-extract-plugin
module.exports = {"root":"Divisor_root__1L3Ff","letter":"Divisor_letter__qC8wp"};